<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="$temAcessoView('CONV-00')"
                >Adicionar
            </b-button>
        </b-button-group>
        <b-modal size="lg" v-model="mostrarModal" no-close-on-backdrop>
            <div slot="modal-title">
                Convênio -
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="vcCodigoEstruturado">Nº do Convênio</label>
                        <b-input-group>
                            <b-form-input
                                id="vcCodigoEstruturado"
                                type="text"
                                placeholder="Nº do Convênio"
                                v-model="convenio.vcCodigoEstruturado"
                                v-mask="'AA###/##'"
                                :disabled="!habilitaCampos"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >Nº do Convênio é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="IdProcessoAta">Ata Direx</label>
                        <b-input-group>
                            <b-form-input
                                id="IdProcessoAta"
                                type="text"
                                placeholder="Ata Direx"
                                v-model="
                                    convenio.processoAta.ataDirex.nuAtaDirex
                                "
                                :disabled="!habilitaCampos"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarAtaDirex()"
                                    title="Clique para pesquisar a Ata Direx"
                                    :disabled="!habilitaCampos"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback
                                >Ata Direx é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col> -->
                <!-- <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="idProcesso">Nº Processo</label>
                        <b-input-group>
                            <b-form-select
                                id="idProcesso"
                                type="text"
                                placeholder="Nº Processo"
                                v-model="convenio.idProcessoAta"
                                :options="convenio.processosAta"
                                value-field="idProcessoAta"
                                text-field="nuProcesso"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                            <b-form-invalid-feedback
                                >Nº Processo é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col> -->
            </b-row>

            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcObjeto">Objeto</label>
                        <b-input-group>
                            <b-form-textarea
                                id="vcObjeto"
                                type="text"
                                v-model="convenio.vcObjeto"
                                placeholder="Objeto"
                                :rows="2"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >Objeto é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="cnpj">Convenente</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="cnpj"
                                v-model="convenio.convenenteRM.cnpj"
                                placeholder="CNPJ"
                                v-mask="['##.###.###/####-##']"
                                :disabled="!habilitaCampos"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarConvenente()"
                                    title="Clique para pesquisar o Convenente"
                                    :disabled="!habilitaCampos"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback
                                >Convenente é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="10">
                    <b-form-group>
                        <label for="nome">Razão Social</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="nome"
                                placeholder="Razão Social"
                                v-model="convenio.convenenteRM.nome"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Tipo Convênio
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            >
                        </label>
                        <b-form-select
                            :options="tiposConveniosRm"
                            v-model="convenio.codTipoConvenio"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Tipo para Faturamento
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            ></label
                        >
                        <b-form-select
                            :options="tiposProdutosFaturamentoRm"
                            v-model="convenio.codTipoProdutoFaturamento"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Natureza
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            ></label
                        >
                        <b-form-select
                            :options="tiposNatureza"
                            text-field="descricao"
                            value-field="codigo"
                            v-model="convenio.codTipoNatureza"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Gestor do Convênio
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            ></label
                        >
                        <b-form-select
                            :options="vendedores"
                            v-model="convenio.codGestorRM"
                            text-field="nome"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Gerente do gestor
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            ></label
                        >
                        <b-form-select
                            :options="vendedores"
                            v-model="convenio.codGerenteGestor"
                            text-field="nome"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group>
                        <label
                            >Representante
                            <b-badge variant="primary" class="ml-2"
                                >Integração com RM</b-badge
                            ></label
                        >
                        <b-form-select
                            :options="representantes"
                            text-field="nome"
                            value-field="codigo"
                            v-model="convenio.codRepresentante"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desativarBotao"
                    @click.stop="salvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object
    },

    validations: {
        valor: {
            required,
            minValue: minValue(0.01)
        }
    },

    data() {
        return {
            tiposConveniosRm: [],
            tiposProdutosFaturamentoRm: [],
            tiposNatureza: [],
            vendedores: [],
            representantes: [],
            habilitaCampos: true,
            tabIndex: 0,
            operacao: '',
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            gestores: [],
            // unidades: [],
            itensPorPagina: 5,

            convenio: {
                idConvenio: 0,
                // idProcessoAta: 0,
                vcObjeto: '',
                vcCodigoEstruturado: '',
                codConvenente: 0,
                codGestor: 0,
                // codUnidade: 0,
                idSituacaoConvenio: 1,
                // processosAta: [],

                convenenteRM: {
                    cnpj: '',
                    codFornecedor: '',
                    email: '',
                    nome: '',
                    telefone: ''
                },
                gestor: {
                    codFuncionario: 0,
                    nome: '',
                    email: ''
                },
                // unidade: {
                //     codUnidade: '',
                //     nome: ''
                // },
                dtInicioVigencia: '',
                dtFimVigencia: '',
                nuValorReceitaPrevista: 0.0,
                totalReceitas: 0.0,
                totalRendimentos: 0.0,
                nuValorConvenio: 0.0
            }
        }
    },

    methods: {
        abrirModal() {
            this.obterGestores()
            // this.obterUnidades()
            this.obterConvenio()
            this.obterTiposConvenios()
            this.ObterTipoProdutoFaturamento()
            this.ObterTipoNatureza()
            this.ObterVendedores()
            this.ObterRepresentantes()

            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterConvenio() {
            this.habilitaCampos = true

            if (this.parentData.convenioId > 0) {
                this.operacao = 'EDIÇÃO'
                this.habilitaCampos = false

                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPorId(this.parentData.convenioId).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data

                                this.habilitaAplicacaoRecursoAcao =
                                    response.data.tipoAplicacaoRecurso == 'A'

                                this.convenio.dtInicioVigencia = this.$moment(
                                    response.data.dtInicioVigencia
                                ).format('DD/MM/YYYY')
                                this.convenio.dtFimVigencia = this.$moment(
                                    response.data.dtFimVigencia
                                ).format('DD/MM/YYYY')

                                // this.pesquisarAtaDirex()
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            } else {
                this.operacao = 'INSERÇÃO'
            }
        },

        salvar() {
            this.convenio.dtInicioVigencia = this.$moment(
                this.convenio.dtInicioVigencia,
                'DD/MM/YYYY'
            ).format('YYYY-MM-DD')
            this.convenio.dtFimVigencia = this.$moment(
                this.convenio.dtFimVigencia,
                'DD/MM/YYYY'
            ).format('YYYY-MM-DD')

            if (this.operacao == 'INSERÇÃO') {
                this.$store.dispatch('addRequest')
                ConveniosServicos.inserirConvenio(this.convenio).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                                this.editarConvenio(response.data.idConvenio)
                                this.obterConvenio()
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            } else {
                this.$store.dispatch('addRequest')
                ConveniosServicos.AlterarConvenio(this.convenio).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                                //this.editarConvenio(response.data.idConvenio)
                                this.obterConvenio()
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            }
        },

        obterGestores() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterGestores().then((response) => {
                if (response) {
                    if (response.success) {
                        this.gestores = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        // obterUnidades() {
        //     this.$store.dispatch('addRequest')
        //     ConveniosServicos.obterUnidades().then((response) => {
        //         if (response) {
        //             if (response.success) {
        //                 this.unidades = response.data
        //             } else {
        //                 this.erros = response.errors
        //             }
        //         }
        //         this.$store.dispatch('removeRequest')
        //     })
        // },

        // pesquisarAtaDirex() {
        //     if (this.convenio.processoAta.ataDirex.nuAtaDirex.length == 7) {
        //         this.$store.dispatch('addRequest')
        //         ConveniosServicos.obterProcessosPorNumeroAta(
        //             this.convenio.processoAta.ataDirex.nuAtaDirex.replace(
        //                 '/',
        //                 '-'
        //             )
        //         ).then((response) => {
        //             if (response) {
        //                 if (response.success && response.data != null) {
        //                     this.erros = []
        //                     this.convenio.processosAta = response.data
        //                 } else {
        //                     this.convenio.processosAta = []
        //                     this.erros = response.errors
        //                 }
        //             }
        //             this.$store.dispatch('removeRequest')
        //         })
        //     }
        // },

        pesquisarConvenente() {
            if (
                this.convenio.convenenteRM.cnpj.length == 14 ||
                this.convenio.convenenteRM.cnpj.length == 18
            ) {
                let cpfcnpjSemCaracteresEspeciais =
                    this.convenio.convenenteRM.cnpj.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterFornecedor(
                    cpfcnpjSemCaracteresEspeciais
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.convenio.codConvenente =
                                response.data.codFornecedor
                            this.convenio.convenenteRM.nome = response.data.nome
                            this.convenio.convenenteRM.codFornecedor =
                                response.data.codFornecedor
                        } else {
                            this.erros.push('Convenente não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterTiposConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTiposConveniosRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposConveniosRm = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterTipoProdutoFaturamento() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTipoProdutoFaturamentoRM().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tiposProdutosFaturamentoRm = response.data
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        ObterTipoNatureza() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterTipoNaturezaRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposNatureza = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterVendedores() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterVendedoresRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.vendedores = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterRepresentantes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterRepresentantesRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.representantes = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
        // 'convenio.idProcessoAta'() {
        //     for (var i = 0, l = this.convenio.processosAta.length; i < l; i++) {
        //         if (
        //             this.convenio.processosAta[i].idProcessoAta ==
        //             this.convenio.idProcessoAta
        //         ) {
        //             this.convenio.vcObjeto =
        //                 this.convenio.processosAta[i].vcObjetoProcesso
        //             //this.convenio.nuValorConvenio = this.convenio.processosAta[i].nuValorGlobalProcesso
        //             return
        //         }
        //     }
        // }
    }
}
</script>
